<template>
  <div id="pedidos-vencendo" class="w3-container w3-margin-top" style="padding: 0;">

    <div class="w3-col w3-margin-bottom" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>
    
    <div v-if="!processando" class="w3-margin-bottom">
      <input 
        type="text"
        v-model="filtro_produtos" 
        v-on:keyup="filtrarProdutos()"
        placeholder="Pesquise por código ou nome do produto"
        class="w3-input w3-border w3-padding margin-bottom-filtro">

      <label>Empresa</label>
      <select 
        @click="mudarPagina(0)"
        v-model="empresa_selecionada_id"
        class="w3-select w3-input w3-border margin-bottom-filtro"
        @change="buscarProdutosPontaEstoque()">
        
        <option
          v-for="empresa in empresas_autorizadas" 
          :value="empresa.empresa_id" 
          :key="empresa.empresa_id">
          {{`${empresa.empresa_id} - ${empresa.nome_fantasia}`}}
        </option>
      </select>

      <label>Marca</label>
      <select 
        @click="mudarPagina(0)" 
        v-model="filtro_marca" 
        class="w3-input w3-border margin-bottom-filtro">
        <option value="">Selecione uma marca</option>
        <option 
          v-for="(marca, marca_index) in marcas" 
          :key="marca_index"
          :value="marca.marca">
          {{marca.marca}}
        </option>
      </select>
    </div>

    <div 
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
      v-if="(Object.keys(produtos_filtrados).length == 0) && !processando"
      v-cloak>
      
      <div class="w3-container w3-white">
        <p>Não há pedidos a serem exibidos.</p>
      </div>
    </div>
    
    <div 
      class="wrapper-componente"
      v-if="(Object.keys(produtos_filtrados).length > 0) && !processando">
      
      <div 
        class="card-item w3-container"
        v-for="(produto, produto_index) in novosPedidosFiltrados"  
        :key="produto_index">

        <div class="w3-col s12">
          <strong class="w3-text-theme"><i class="fas fa-box"></i>&nbsp;{{produto.produto_id}} - {{produto.nome}} - {{produto.unidade}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Marca: </label>
          <strong>{{produto.marca}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Quantidade: </label>
          <strong>{{produto.qtd_disponivel_ponta_estoque}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Quantidade rede: </label>
          <strong>{{produto.qtd_disp_ponta_estoque_rede}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Preço Venda: </label>
          <strong>{{nPadraoReais(produto.preco_venda)}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Preço ponta: </label>
          <strong>{{nPadraoReais(produto.preco_ponta_estoque)}}</strong>
        </div>
        
      </div>
    </div>
    
    <paginacao 
      v-if="!processando"
      @pagina="mudarPagina" 
      :pagina-atual="paginaAtual" 
      :itens-por-pagina="itensPorPagina"
      :total-resultados="totalResultados"
      :total-de-paginas="totalDePaginas"/>
  </div>
</template>

<script>
  import store from '@/ambiente/store';
  import Paginacao from '@/components/Paginacao'
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import RProdutoBuscarProdutosPontaEstoqueDashboard from '@/components/Rest/RProduto/RProdutoBuscarProdutosPontaEstoqueDashboard.js'
  
  export default {
    name: 'ProdutosPontaEstoque',
    
    components: {
      Paginacao
    },
    
    data() {
      return {
        api: process.env.API,
        produtos_ponta_estoque: [],
        qtd_produtos_ponta_estoque: 0,
        processando: false,
        filtro_produtos: '',
        filtro_marca: '',
        produtos_filtrados: [],
        paginaAtual: 0,
        itensPorPagina: 10,
        totalResultados: 0,
        totalDePaginas: 0,
        empresas_autorizadas: [],
        empresa_selecionada_id: 0
      }
    },
    mounted() {
      this.filtro_marca = ''
      
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },
  
    methods: {
      mudarPagina(numeroDaPagina) {
        this.paginaAtual = numeroDaPagina;
      },

      limparResultados(){
        this.paginaAtual = 0;
        this.itensPorPagina = 10;
        this.totalResultados = 0;
        this.totalDePaginas = 0;
        this.produtos_filtrados = [];
        this.produtos_ponta_estoque = [];
        this.confirmarQtdProdutoPontaEstoque(0);
      },

      async buscarQuantidadeTotalProdutosPontaEstoque(){       
        this.confirmarQtdProdutoPontaEstoque(this.qtd_produtos_ponta_estoque);  
      },

      confirmarQtdProdutoPontaEstoque(qtd_produtos){
        this.$emit(
          'quantidade_produto_ponta_estoque', 
          {quant_produto: qtd_produtos}
        );
      },
      
      filtrarProdutos() {
        this.produtos_filtrados = [];
        this.mudarPagina(0);
      
        if(this.filtro_produtos == '') {
          this.produtos_filtrados = JSON.parse(JSON.stringify(this.produtos_ponta_estoque));
          return;
        }

        this.filtro_produtos = this.filtro_produtos.toUpperCase();
        for (let i = 0; i < this.produtos_ponta_estoque.length; i++) {
          if (this.produtos_ponta_estoque[i].nome.toUpperCase().indexOf(this.filtro_produtos) > -1) {
            this.produtos_filtrados.push(this.produtos_ponta_estoque[i]);
          }

          if (this.produtos_ponta_estoque[i].produto_id.replace(".", "").indexOf(this.filtro_produtos) > -1) {
            this.produtos_filtrados.push(this.produtos_ponta_estoque[i]);
          } 
        }
      },
  
      async buscarProdutosPontaEstoque() {
        try {
          this.processando = true;
          this.limparResultados();
          
          let parametros = {
            empresa_id: this.empresa_selecionada_id
          };
        
          let retorno = await RProdutoBuscarProdutosPontaEstoqueDashboard.buscarProdutosPontaEstoqueDashboard(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          if (retorno.dados) {
            this.produtos_ponta_estoque = JSON.parse(JSON.stringify(retorno.dados));
            this.produtos_filtrados = JSON.parse(JSON.stringify(this.produtos_ponta_estoque));
            this.confirmarQtdProdutoPontaEstoque(this.produtos_filtrados.length);
          }

          this.processando = false;
        }
        catch (error) {
          this.processando = false;
          Biblioteca.exclamar(error.message);
        }
      },

      nPadraoReais(valor){
        return Biblioteca.nPadraoReais(valor);
      },
    },

    async created() {
      this.empresas_autorizadas = await JSON.parse(JSON.stringify(await store.state.empresas_autorizadas));
      this.empresa_selecionada_id = await store.state.empresa_logada.empresa_id;
      await this.buscarProdutosPontaEstoque();

      this.qtd_produtos_ponta_estoque = 0;
      if (this.produtos_ponta_estoque){
        this.qtd_produtos_ponta_estoque = this.produtos_ponta_estoque.length;
      }
    },

    computed: {
      novosPedidosFiltrados() {
        let produtos_lista_filtrada = JSON.parse(JSON.stringify(this.produtos_filtrados));
        if (this.filtro_marca) {
          produtos_lista_filtrada = produtos_lista_filtrada.filter(obj => {
            return obj.marca === this.filtro_marca;
          })
        }

        this.totalResultados = produtos_lista_filtrada.length;
        this.totalDePaginas =  Math.ceil(this.totalResultados / this.itensPorPagina);
        
        if (this.paginaAtual >= this.totalDePaginas) { 
          this.paginaAtual = this.totalDePaginas;
        }

        let index = this.paginaAtual * this.itensPorPagina
        return produtos_lista_filtrada.slice(index, index + this.itensPorPagina);
      },

      marcas() {
        let produtos_lista_filtrada = this.produtos_filtrados;
        let lista_marcas = produtos_lista_filtrada.filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t.marca === thing.marca
          ))
        );

        lista_marcas.sort(function(a, b) {
          let textA = a.marca.toUpperCase();
          let textB = b.marca.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        return lista_marcas;
      },
    }
  }
</script>
<style scoped>
  th, .nowrap {
    white-space: nowrap !important;
  }

  .card-item  {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
  
  .titulo {
    white-space: nowrap;
    text-align: right
  }
  
  td {
    white-space: nowrap;
  }
  
  .produtos-em-promocao {
    overflow: auto;
  }
  
  .wrapper-componente {
    overflow: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ProdutosPontaEstoque.vue